import React, {useEffect} from 'react';
import analytics from '@react-native-firebase/analytics';
import {useNavigation, useRoute} from '@react-navigation/native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTheme} from 'styled-components/native';

import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {EmprestimoEligibilityGate} from '../../../components/shared/EmprestimoEligibilityGate';

import {
  Container,
  Content,
  OptionCard,
  OptionCardInner,
  OptionIconWrapper,
  OptionIcon,
  OptionTextBlock,
  OptionTitle,
  OptionDescription,
  ChevronIcon,
} from './styles';

type TipoDoc = 'rg' | 'cnh';

type RouteParams = {
  simulacao: any;
  installments_option_id: string;
  selectedOption: any;
  endereco_id: string;
  domicilio_id: string;
};

export function EmprestimoTipoDocumento() {
  const navigation = useNavigation();
  const route = useRoute();
  const theme = useTheme();
  const params = route.params as RouteParams;

useEffect(() => {
  analytics().logEvent('emprestimo_tela_tipo_documento');
}, []);

  const handleSelect = (tipoDoc: TipoDoc) => {
  (navigation as any).navigate('EmprestimoDocumentos', {
    ...params,
    tipo_doc: tipoDoc,
  });
};

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      <EmprestimoEligibilityGate />
      <Header icon="chevron-left" />
      <Container>
        <Content>
          <Titles
            title="Tipo de documento"
            subtitle="Selecione o documento que você vai usar para verificar sua identidade."
          />

          <OptionCard
            underlayColor={theme.colors.button_click_bg}
            onPress={() => handleSelect('rg')}>
            <OptionCardInner>
              <OptionIconWrapper>
                <OptionIcon name="card-account-details" />
              </OptionIconWrapper>
              <OptionTextBlock>
                <OptionTitle>RG</OptionTitle>
                <OptionDescription>Registro Geral</OptionDescription>
              </OptionTextBlock>
              <ChevronIcon name="chevron-right" />
            </OptionCardInner>
          </OptionCard>

          <OptionCard
            underlayColor={theme.colors.button_click_bg}
            onPress={() => handleSelect('cnh')}>
            <OptionCardInner>
              <OptionIconWrapper>
                <OptionIcon name="car" />
              </OptionIconWrapper>
              <OptionTextBlock>
                <OptionTitle>CNH</OptionTitle>
                <OptionDescription>Carteira Nacional de Habilitação</OptionDescription>
              </OptionTextBlock>
              <ChevronIcon name="chevron-right" />
            </OptionCardInner>
          </OptionCard>
        </Content>
      </Container>
    </SafeAreaView>
  );
}
